module.exports = __webpack_public_path__ + "img/icon_yuezhifu.85512f54.png";